import { render, staticRenderFns } from "./chooseTemplate.vue?vue&type=template&id=901e055c&"
import script from "./chooseTemplate.vue?vue&type=script&lang=js&"
export * from "./chooseTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports